(function () {
const __pewniaki_inline_cfg = JSON.parse(document.currentScript.previousElementSibling.textContent);
var rozpText = (function(){var texts={"one": __pewniaki_inline_cfg[0],"mean": __pewniaki_inline_cfg[1],"model": __pewniaki_inline_cfg[2],"missingModel": __pewniaki_inline_cfg[3],"median": __pewniaki_inline_cfg[4],"empty": __pewniaki_inline_cfg[5],"missing": __pewniaki_inline_cfg[6]};return function(key,params){return texts[key].replace(/\$\{(\w+)\}/g,function(_,name){return String(params[name]);});};})();

window.PEWNIAKI_ANALIZA = {
    plik:   '/assets/json/db/' + __pewniaki_inline_cfg[7] + '/analizy/struktura.json',
    wersja: __pewniaki_inline_cfg[8],
    lata:   '/assets/json/db/' + __pewniaki_inline_cfg[9] + '/lata/',
    pula:   JSON.parse(String(__pewniaki_inline_cfg[10])),
    typuje: JSON.parse(String(__pewniaki_inline_cfg[11])),
    // Zakres lat: suma SUROWYCH licznikow rozpietosci z rocznikow (plan V2 §5.3).
    sumujLata: function (roczniki) {
        var rozp = {}, N = 0;
        roczniki.forEach(function (r) {
            N += Number(r.losowan) || 0;
            Object.keys(r.rozpietosc || {}).forEach(function (d) { rozp[d] = (rozp[d] || 0) + (Number(r.rozpietosc[d]) || 0); });
        });
        return { losowan: N, rozpietosc: rozp };
    },
    // Poprawna wartosc modelu to skonczona liczba (takze zapisana jako napis). Brak/null -> null, nie 0.
    wart: function (v) {
        if (typeof v === 'string' && v.trim() !== '') { v = Number(v); }
        return (typeof v === 'number' && isFinite(v)) ? v : null;
    },
    // Wspolne liczenie dla render i wnioski — jedna droga, te same liczby.
    licz: function (okno, dane) {
        var A = window.PEWNIAKI_ANALIZA;
        var rozp = (okno && okno.rozpietosc) || {}, N = Number(okno && okno.losowan) || 0;
        var pula = (dane && dane.pula) || A.pula, typuje = (dane && dane.typuje) || A.typuje;
        var klucze = Object.keys(rozp).map(Number).sort(function (a, b) { return a - b; });
        var sumaD = 0, skum = 0, mediana = null;
        klucze.forEach(function (d) { sumaD += d * (Number(rozp[d]) || 0); });
        for (var i = 0; i < klucze.length; i++) { skum += Number(rozp[klucze[i]]) || 0; if (N > 0 && skum * 2 >= N) { mediana = klucze[i]; break; } }
        var model = (dane && dane.model && dane.model.rozpietosc) || {};
        var modelPelny = Object.keys(model).length > 0, modSr = 0;
        for (var d = typuje - 1; d <= pula - 1; d++) {
            var v = A.wart(model[d]);
            if (v == null) { modelPelny = false; } else { modSr += d * v; }
        }
        return { rozp: rozp, N: N, klucze: klucze, srednia: N > 0 ? sumaD / N : null, mediana: mediana,
                 model: model, modelPelny: modelPelny, modSr: modelPelny ? modSr : null, pula: pula, typuje: typuje };
    },
    // Wykres jest renderowany po stronie serwera i nie umie sie odswiezyc — chowamy go
    // przy kazdej zmianie zakresu, zeby nie pokazywac liczb z poprzedniego okna.
    schowajWykres: function () {
        var box = document.querySelector('[data-hist-kontener="rozpietosc"]');
        var info = document.querySelector('[data-hist-info="rozpietosc"]');
        if (box) { box.hidden = true; }
        if (info) { info.hidden = false; }
    },
    wnioski: function (o, klucz, dane) {
        if (!o) return [rozpText('missing')];
        var w = window.PEWNIAKI_ANALIZA.licz(o, dane), p = [], zd = null;
        var f1 = function (v) { return (Math.round(v * 10) / 10).toString().replace('.', /^en(?:-|$)/i.test(document.documentElement.lang||'') ? '.' : ','); };
        var tys = function (v) { return String(v).replace(/\B(?=(\d{3})+(?!\d))/g, ' '); };
        if (w.N === 1 && w.mediana != null) {
            zd = rozpText('one',{n:w.mediana});
        } else if (w.srednia != null) {
            zd = rozpText('mean',{n:tys(w.N),mean:f1(w.srednia)});
        }
        if (zd != null) {
            if (w.modSr != null) {
                var hist = w.N === 1 ? w.mediana : w.srednia;
                zd += rozpText('model',{mean:f1(w.modSr),diff:f1(Math.abs(hist-w.modSr))});
            } else {
                zd += rozpText('missingModel');
            }
            p.push(zd);
        }
        if (w.N > 1 && w.mediana != null) p.push(rozpText('median',{median:w.mediana,n:tys(w.N)}));
        return p.length ? p : [rozpText('empty')];
    },
    render: function (okno, klucz, dane) {
        var q = function (s) { return document.querySelector(s); };
        var tys = function (v) { return String(v).replace(/\B(?=(\d{3})+(?!\d))/g, ' '); };
        var f1 = function (v) { return v == null ? '—' : (Math.round(v * 10) / 10).toString().replace('.', /^en(?:-|$)/i.test(document.documentElement.lang||'') ? '.' : ','); };
        var A = window.PEWNIAKI_ANALIZA, sekcja = q('[data-rozpietosc]'), brak = q('[data-rozpietosc-brak]');
        if (window.PEWNIAKI_HISTOGRAM) window.PEWNIAKI_HISTOGRAM(sekcja, 'rozpietosc', okno, {model:((dane || {}).model || {}).rozpietosc || {}, latest:okno ? okno.ostatnia_rozpietosc : null});
        if (!okno) { if (sekcja) { sekcja.hidden = true; } if (brak) { brak.hidden = false; } return; }
        if (sekcja) { sekcja.hidden = false; }
        if (brak) { brak.hidden = true; }
        var w = A.licz(okno, dane), N = w.N, rozp = w.rozp, model = w.model;
        var pula = w.pula, typuje = w.typuje;
        var modelBrak = q('[data-rozpietosc-model-brak]');
        if (modelBrak) { modelBrak.hidden = w.modelPelny; }
        q('[data-rozpietosc-n]').textContent = tys(N);
        q('[data-rozpietosc-srednia]').textContent = f1(w.srednia);
        q('[data-rozpietosc-mediana]').textContent = w.mediana != null ? w.mediana : '—';
        q('[data-rozpietosc-model]').textContent = f1(w.modSr);
        q('[data-rozpietosc-min]').textContent = w.klucze.length ? w.klucze[0] : '—';
        q('[data-rozpietosc-max]').textContent = w.klucze.length ? w.klucze[w.klucze.length - 1] : '—';
        // TOP 10 rozpietosci — kolumna modelu per wartosc: brak = kreska, 0 = 0,0%
        var top = w.klucze.slice().sort(function (a, b) { return (rozp[b] || 0) - (rozp[a] || 0) || a - b; }).slice(0, 10);
        q('[data-rozpietosc-top] tbody').innerHTML = top.map(function (d) {
            var ile = Number(rozp[d]) || 0, v = A.wart(model[d]);
            return '<tr><td class="liczbowa">' + d + '</td><td class="liczbowa">' + tys(ile) + '</td><td class="liczbowa">'
                 + (N ? f1(ile * 100 / N) + '%' : '—') + '</td><td class="liczbowa">' + (v != null ? f1(v * 100) + '%' : '—') + '</td></tr>';
        }).join('');
        // przedzialy po 5, od typuje-1 do pula-1; jeden brakujacy skladnik = suma modelowa niedostepna
        var wiersze = [];
        for (var od = typuje - 1; od <= pula - 1; od += 5) {
            var koniec = Math.min(od + 4, pula - 1), obs = 0, mod = 0, modOk = true;
            for (var d = od; d <= koniec; d++) {
                obs += Number(rozp[d]) || 0;
                var v = A.wart(model[d]);
                if (v == null) { modOk = false; } else { mod += v; }
            }
            wiersze.push('<tr><td>' + od + '–' + koniec + '</td><td class="liczbowa">' + tys(obs) + '</td><td class="liczbowa">'
                + (N ? f1(obs * 100 / N) + '%' : '—') + '</td><td class="liczbowa">' + (modOk ? f1(mod * 100) + '%' : '—') + '</td></tr>');
        }
        q('[data-rozpietosc-hist] tbody').innerHTML = wiersze.join('');
    }
};
})();
